import React from 'react'

import EmptyState from '../EmptyState'

export default function Error404() {
  return (
    <EmptyState>
      <h2>The page you’ve requested could not be found.</h2>
    </EmptyState>
  )
}
